/** 管理后台：小程序 OpenID 绑定状态展示（列表用标签，详单可展示完整值） */

export function wxBindBadge(wx?: string | null): { bound: boolean; label: string; title?: string } {
  const t = wx?.trim();
  if (!t) return { bound: false, label: "未绑定" };
  return { bound: true, label: "已绑定", title: t };
}
